import "./sentry.js";
import "./bootstrap";

import jsQR from "jsqr";
window.jsQR = jsQR;

import "./data";
import "./directives";
